import { render, staticRenderFns } from "./FocusAreasProjectTwo-View.vue?vue&type=template&id=40ccf071&scoped=true&"
import script from "./FocusAreasProjectTwo-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./FocusAreasProjectTwo-View.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccf071",
  null
  
)

export default component.exports